<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
<mat-drawer-container class="example-container" autosize>
  <!-- <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner> -->
  <mat-drawer style="transform: none !important; box-shadow: 0px 4px 40px 2px rgba(200, 196, 196, 0.5);"
    [ngStyle]="{'display': changeFilterRoute() ? 'none' : 'block' }" *ngIf="!CheckLogoutRoute()" opened="true" #drawer
    class="example-sidenav" mode="side">
    <img src="../assets/images/Ignite Logo Black Transparent-PhotoRoom.png" alt="" class="logo">

    <div class="menuCont">
      <ng-material-multilevel-menu #menu [configuration]='config' [items]='appitems'
        (selectedItem)="selectedItem($event)">
        <ng-template #listTemplate let-item="item" let-configuration="configuration">
          <div class="my-cool-menu-item" [dir]="configuration.rtlLayout ? 'rtl' : 'ltr'"
          [ngClass]="{
            'selected-amml-item active-amml-item': item.isActive,
            'dropdownItem': item.isDropdownItem && item.isSelected
          }">
            <div [routerLink]="item?.link" routerLinkActive="activeItem" class="title-and-image"
              (click)="selectedItem(item)">
              <div class="icon-container">
                <i class="aaa" [ngClass]="item?.faIcon"></i>
              </div>
              <div class="label-container">
                <span>{{item.label}}</span>
              </div>
            </div>
          </div>
        </ng-template>


      </ng-material-multilevel-menu>
    </div>
  </mat-drawer>

  <mat-drawer-content [ngStyle]="{'margin-left': changeFilterRoute() ? '0px' : '230px', 'margin-right': changeFilterRoute() ? '0px' : '14px' }" style="margin-left: 230px; margin-right: 230px;"
    [style.margin-left]="!CheckLogoutRoute() ? '230px' : (CheckLogoutRoute() ? '0px' : null)">
    <div *ngIf="isImpersonating && !CheckLogoutRoute()" style="display:flex;align-items:center;justify-content:space-between;padding:10px 14px;background:#fff6d9;border:1px solid #f1d46a;border-radius:8px;margin:8px 12px;">
      <span style="font-size:14px;font-weight:600;">Impersonating: {{ impersonatedUserLabel }}</span>
      <button mat-stroked-button color="warn" (click)="stopImpersonation()">Stop Impersonation</button>
    </div>
    <div class="show_hide_btn" (click)="showHideMenu()" *ngIf="!programPageRoute() && !CheckLogoutRoute() && !historyPageRoute() && !AnalyticsPageRoute() && !libraryPageRoute() && !personalAnalyticsPageRoute() && !ProfilePageRoute()"><img src="../assets/images/menubar.svg" alt=""></div>

    <div class="mobile-drawer-wrapper">
      <div (click)="closeMenu()" [ngClass]="{'drawer-overlay-hide': !showMenu}" class="drawer-overlay"></div>
      <div class="mobile_drawer" *ngIf="showMenu && !CheckLogoutRoute()">
        <div (click)="closeMenu()" class="close_btn"><mat-icon>close</mat-icon></div>
        <div class="outer-box">
          <img (click)="goToDashboard()" src="./../assets/images/Ignite Logo Black Transparent-PhotoRoom.png" alt="" class="logo">
        <!-- <ng-template  #listTemplate let-configuration="configuration"> -->
          <div [ngClass]="{ 'displayNone': item.label === 'Management' || item.label === 'Creation Center', 'marginTop': item.label === 'Logout'}" (selectedItem)="selectedItem($event)" *ngFor="let item of appitems; let i = index" class="my-cool-menu-item" >
            <div class="item_menu" (click)="showDropdownItemsMenu(i, item)">
              <div class="icon-container" (click)="closeDrawer(item)" [routerLink]="item?.link">
                <i class="aaa" [ngClass]="item?.faIcon"></i>
              </div>
              <div class="label-container item-menu-label" (click)="closeDrawer(item)" routerLinkActive="activeItem" [routerLink]="item?.link">
                <span>{{item.label}}</span>
              </div>
              <div class="fl" *ngIf="item.items && showdropdown">
                <div *ngFor="let item of item.items" class="my-cool-menu-item" >
                  <div (click)="hideDrawer(item)" [routerLink]="item?.link" (click)="onClickActionMobile(item.label)">
                    <!-- <div class="icon-container">
                      <i class="aaa" [ngClass]="item?.faIcon"></i>
                    </div> -->
                    <div class="label-container">
                      <span>{{item.label}}</span>
                    </div>
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </ng-template> -->

      </div>
    </div>

    <div class="example-sidenav-content">
      <!-- <button type="button" mat-button (click)="drawer.toggle()">
        <mat-icon aria-hidden="false" aria-label="Example menu icon" fontIcon="menu"></mat-icon>
      </button> -->
      <router-outlet></router-outlet>
    </div>

    <!-- <div id="help-button" title="Ignite Humans Help & Support" (click)="openHelpSupportModal()">
      <button class="fx_btn" mat-raised-button mat-button>
          <img src="../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
      </button>

  </div> -->

  <div *ngIf="!isMandatoryPasswordChangeRoute()" [ngClass]="{'isPipPresent': isPipOpened}" id="help-button" (click)="openHelpSupportModal()">
    <span class="help-text">Help & Feedback !</span>
    <button class="fx_btn" mat-raised-button mat-button>
      <img src="../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
    </button>

  </div>

  <div class="pwaPopup">
    <!-- <p>isPwa {{isPWA}}</p>
    <p>closeInstallBanner {{closeInstallBanner}}</p>
    <p>isMobile {{isMobile}}</p>
    <p>isiPhone {{isiPhone}}</p> -->

    <ng-container *ngIf="showPwaPrompt && !closeInstallBanner && isMobile">
      <div class="install_prompt" (click)="addToHome()">
        <div class="header">
          <img src="../assets/icons/icon-72.png">
          TAP HERE TO INSTALL APP
        </div>
        <div class="closeBtn" (click)="closeBanner()">
          <img src="../../../../../assets/images/crossbtn.svg" />
      </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isIOSPWA && !closeInstallBanner && isiPhone">
      <div class="install_prompt" (click)="clickForIosAlert()">
        <div class="header" (click)="openMobileInfoModal()">
          <img src="../assets/icons/icon-72.png">
          <!-- 'Add to Home Screen' to install app -->
          Tap to save app on your phone
        </div>
        <div class="closeBtn" (click)="closeBanner()">
          <img src="../../../../../assets/images/crossbtn.svg" />
      </div>
      </div>
    </ng-container>
  </div>


  <div cdkDrag *ngIf="isPipOpened" class="custom-pip-box" cdkDragBoundary=".example-container">
    <div cdkDragHandle class="drag-handle1"></div>
    <div cdkDragHandle class="drag-handle2"></div>
    <div cdkDragHandle class="drag-handle3"></div>
    <div cdkDragHandle class="drag-handle4"></div>
    <div cdkDragHandle class="drag-handle5"></div>
    <app-custom-pip></app-custom-pip>
  </div>

  <div id="custom_toast_box" *ngIf="customToastText && customToastText.length >= 1">
	<button (click)="closeCustomToast()" id="custom_toast_close_btn">&times;</button>
	{{ customToastText }}
  </div>

  </mat-drawer-content>
</mat-drawer-container>
